module.exports = __webpack_public_path__ + "0b9f04ed38c4bdead20f47f9d5e225df.MP3";